import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Tooltip } from 'antd';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import { ColumnResizer } from '../styles';

const NAMESPACES = ['DYNAMIC_TABLE_OPERATIONS'];

const ResizableColumn = (props) => {
  const { itemUUID, uuid, rowIndex, onResize, scaling, customClassName = '', isStatic = false, onAddRow } = props;
  const [isLeft, toggleLeft] = useState(true);
  const ref = useRef(null);
  const { t } = useTranslation(NAMESPACES);

  const [ , drag, preview ] = useDrag({
    item: {
      uuid,
      itemUUID,
      rowIndex,
      type: "row-resize",
    },
    begin: () => ({
      uuid,
      itemUUID,
      rowIndex,
      type: "row-resize",
    }),
    end: (item, monitor) => {
      onResize(
        uuid,
        rowIndex,
        (monitor.getSourceClientOffset().y - monitor.getInitialSourceClientOffset().y) / scaling
      );
    },
    collect: monitor => ({
      isResizing: !!monitor.isDragging()
    })
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  const onMouseOver = useCallback((e) => {
    e.persist();
    const bounds = ref.current?.getBoundingClientRect();
    toggleLeft(previousValue => {
      return e.nativeEvent.clientX < (bounds?.left + (bounds?.width / 2));
    });
  }, []);

  drag(ref);

  const extraStyles = isLeft ? { left: -25 } : { left: 'calc(100% + 5px)' };

  return (
    <>
      <ColumnResizer ref={ref} left={0} leftStart={2} isStatic={isStatic} className={customClassName} horizontal={true} top={props.topStart - 3} width={6}
        onMouseOver={onMouseOver}
      >
          <Tooltip
            title={"Add Row"}
          >
            <div className={`addColumnOptions hoverButton ${isLeft ? 'left' : 'right'}`}
              id={`add-row-${itemUUID}-${rowIndex}`}
              style={{ top: '-10px', ...extraStyles }}
              onClick={onAddRow}
            >
              +
            </div>
          </Tooltip>
      </ColumnResizer>
    </>
  )
}

export default ResizableColumn;